import { QueryClient } from '@tanstack/react-query'

import { APP_CONFIG } from '@/config/app.config'

/** Create a QueryClient pre-configured with the app's caching defaults. */
export function createQueryClient(): QueryClient {
  return new QueryClient({
    defaultOptions: {
      queries: {
        staleTime: APP_CONFIG.query.staleTimeMs,
        gcTime: APP_CONFIG.query.gcTimeMs,
        retry: APP_CONFIG.query.retry,
        refetchOnWindowFocus: false,
      },
    },
  })
}
